import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";

const CardModal = ({ image_path, title }) => {
  return (
    <Card
      variant="outlined"
      orientation="horizontal"
      className="w-full hover:shadow-md hover:border-neutral-outlinedHoverBorder cursor-pointer"
    >
      <AspectRatio ratio="1" className="w-12">
        <img
          src={image_path !== "" ? image_path : "./assets/logo/logo.png"}
          loading="lazy"
          alt="logo del evento"
        />
      </AspectRatio>
      <CardContent className="flex items-center">
        <Typography
          level="title-lg"
          id="card-description"
          className="text-base sm:text-lg"
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardModal;
